export default __webpack_public_path__ + "static/media/7.ec6e8837.jpg";